import Vue from 'vue'
import i18n from '@/i18n'

export const translate_action_type = (type: string): string => {
    const translationKey = `action.type.${type}`
    const translation = i18n.t(translationKey).toString()

    if (translation === translationKey) {
        return type
    }

    return translation
}
Vue.filter('translate_action_type', translate_action_type)
